import {
    blackListWindowNames,
    blackListWindowReferrerRegexp,
} from '@bg-shared/constants/blackList';

export const isBlacklisted = (): boolean => {
    const { referrer } = document;
    const { name } = window;

    return (
        (referrer.length && blackListWindowReferrerRegexp.test(referrer)) ||
        (name?.length && blackListWindowNames.includes(name))
    );
};
